
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#000","d":"M4 20a2 2 0 002 2h7.17c.533 0 1.044-.212 1.42-.59l4.82-4.82c.378-.376.59-.887.59-1.42V13H4v7zm9-4a1 1 0 011-1h4.18L13 20.18V16zm8.5-7H20V4a2 2 0 00-2-2H6a2 2 0 00-2 2v5H2.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z"}})])])
          )
        }
      }
    